import { useState } from "react";
import { Alert } from "react-bootstrap";
import util from "../../../utiles/miniUtiles";
import Swal from "sweetalert2";
import axios from "axios";

/**
 * Component for converting a PDF file to a CSV file.
 * 
 * This component allows users to select a PDF file and convert it to a CSV file.
 * The PDF file must be in the format of a bank statement.
 */
const ConvertPdfToCsv = () => {

    const [file, setFile] = useState(null);

    const handleFileChange = (event: any) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = async () => {
        if (!file) {
            alert("Please select a file first!");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        try {
            const GL_API_URL = process.env.REACT_APP_GL_API_URL;
            const response = await axios.post(GL_API_URL + "/auth/convert-pdf-to-csv", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "api-secret": process.env.REACT_APP_API_SECRET!,
                    "api-key": process.env.REACT_APP_API_KEY!,
                    "user-id": 116,
                },
                responseType: "json",
            });
            const { error, msg, data } = response.data;
            if (error) throw new Error(msg);
            // Handle the response as needed
            // Convert JSON to CSV
            const csvBlob = new Blob([response.data], { type: "text/csv" });
            const csvUrl = URL.createObjectURL(csvBlob);

            // Create download link
            const a = document.createElement("a");
            a.href = csvUrl;
            a.download = "converted_file.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(csvUrl); // Free memory

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "File uploaded successfully!",
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Error uploading file!",
            });
            console.error("Error uploading file:", error);
        }
    };


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                            <div className="main-container-inner">
                                <div className="main-card revrex-data-table-card">
                                    <div className='d-flex justify-content-between align-items-center mb-3'>
                                        <h1 className='page-title-sm'>Convert Pdf To Csv</h1>
                                    </div>
                                    <Alert variant='info'>
                                        <p>
                                            This tool is used to convert a PDF file to a CSV file. The PDF file must be in the format of a bank statement.
                                        </p>
                                    </Alert>
                                    <div className="main-card-body">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="d-flex flex-column">
                                                        <div>
                                                            <label htmlFor="pdfFile">Select PDF File</label>
                                                            <input
                                                                type="file"
                                                                accept=".pdf"
                                                                onChange={handleFileChange}
                                                                className="form-control-file"
                                                                id="pdfFile" />
                                                        </div>
                                                        <button
                                                            disabled={!file}
                                                            className="mt-2 btn btn-primary"
                                                            onClick={handleSubmit}
                                                        >
                                                            Convert PDF to CSV
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ConvertPdfToCsv;